import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { useForm } from "../../components/forms/useForm";
import wipSyncLogo from "../../assets/wip-sync-logo.png";
import Button from "../../components/controls/Button";

const initialValues = {
  email: "",
  password: "",
};

const Login = (props) => {
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("email" in fieldValues) {
      temp.email =
        fieldValues.email.length !== 0 ? "" : "This field is required.";
    }
    if ("password" in fieldValues) {
      temp.password =
        fieldValues.password.length !== 0 ? "" : "This field is required.";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === "");
    }
  };

  const { values, errors, setErrors, handleInputChange } = useForm(
    initialValues,
    false,
    validate,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      props.onAuth(values.email, values.password);
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden font-sans bg-surface">
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 20% 10%, rgba(22, 155, 149, 0.18), transparent 55%), radial-gradient(ellipse 70% 50% at 90% 90%, rgba(11, 31, 58, 0.12), transparent 50%), linear-gradient(160deg, var(--color-surface) 0%, var(--color-accent-soft) 45%, #EEF2F7 100%)",
        }}
      />
      <div className="pointer-events-none absolute -left-24 top-24 h-72 w-72 rounded-full bg-accent opacity-30 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-10 h-80 w-80 rounded-full bg-brand opacity-20 blur-3xl" />

      <div className="absolute left-6 top-6 z-10 flex items-center gap-3 sm:left-8 sm:top-8">
        <img
          src={wipSyncLogo}
          alt=""
          className="h-12 w-12 object-contain drop-shadow-sm sm:h-14 sm:w-14"
        />
        <span className="text-xl font-bold tracking-tight text-brand sm:text-2xl">
          WIP Sync
        </span>
      </div>

      <div className="relative flex min-h-screen flex-col justify-center px-6 py-12 lg:px-8">
        <div className="mx-auto w-full max-w-[420px]">
          <div className="mb-10 flex flex-col items-center text-center">
            <h1 className="text-4xl font-bold tracking-tight text-brand sm:text-5xl">
              WIP Sync
            </h1>
            <p className="mt-3 max-w-sm text-base leading-relaxed text-slate-500">
              Sign in to manage inventory, production, and traceability.
            </p>
          </div>

          <form
            className="space-y-5 rounded-2xl border border-border-subtle/80 bg-card/80 p-7 shadow-soft backdrop-blur-md sm:p-8"
            onSubmit={handleSubmit}
          >
            <div>
              <label
                htmlFor="email"
                className="mb-1.5 block text-sm font-medium text-brand"
              >
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                placeholder="you@company.com"
                className="input-brand"
                onChange={handleInputChange}
              />
              {errors.email ? (
                <p className="mt-1.5 text-xs font-medium text-danger">
                  {errors.email}
                </p>
              ) : null}
            </div>

            <div>
              <label
                htmlFor="password"
                className="mb-1.5 block text-sm font-medium text-brand"
              >
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                placeholder="Enter your password"
                className="input-brand"
                onChange={handleInputChange}
              />
              {errors.password ? (
                <p className="mt-1.5 text-xs font-medium text-danger">
                  {errors.password}
                </p>
              ) : null}
            </div>

            <Button
              type="submit"
              loading={props.loading}
              className="w-full py-2.5"
            >
              Sign in
            </Button>

            {props.error ? (
              <p className="rounded-xl border border-red-100 bg-red-50 px-3 py-2 text-center text-sm text-danger">
                {props.error.subtitle ||
                  props.error.title ||
                  "Could not login. Check your credentials and try again."}
              </p>
            ) : null}
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user_id: state.auth.user_id,
    fname: state.auth.fname,
    lname: state.auth.lname,
    loading: state.auth.loading,
    error: state.auth.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (email, password) => dispatch(actions.auth(email, password)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
